// @ts-nocheck

import { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ReduxState } from '../redux/rootReducer'
import { addLocationAction } from '../redux/User/actions'
import { listEventsRequestAction } from '../redux/Content/actions'
import { clearEvent } from '../redux/Event/actions'

function calculateDistance(
  lat1: number,
  lon1: number,
  lat2: number,
  lon2: number
) {
  if (lat1 === lat2 && lon1 === lon2) {
    return 0
  }

  const radlat1 = (Math.PI * lat1) / 180
  const radlat2 = (Math.PI * lat2) / 180
  const theta = lon1 - lon2
  const radtheta = (Math.PI * theta) / 180
  let dist =
    Math.sin(radlat1) * Math.sin(radlat2) +
    Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta)

  if (dist > 1) {
    dist = 1
  }

  dist = Math.acos(dist)
  dist = (dist * 180) / Math.PI
  dist = dist * 60 * 1.1515

  return dist
}

export function useAutoLocation() {
  const dispatch = useDispatch()
  const location = useSelector(
    (state: ReduxState) => state.UserReducer.location
  )
  const LocationReducer = useSelector(
    (state: ReduxState) => state.LocationReducer
  )
  const geoRequestedRef = useRef(false)

  useEffect(() => {
    if (location || geoRequestedRef.current || LocationReducer.length === 0) {
      return
    }

    if (typeof navigator === 'undefined' || !navigator.geolocation) {
      return
    }

    geoRequestedRef.current = true

    navigator.geolocation.getCurrentPosition(
      ({ coords }) => {
        const calcDistance = LocationReducer.map((city) =>
          calculateDistance(
            coords.latitude,
            coords.longitude,
            city.latitude,
            city.longitude
          )
        )

        const menor = Math.min.apply(null, calcDistance)
        const geoCity = LocationReducer[calcDistance.indexOf(menor)].nome

        dispatch(addLocationAction(geoCity))
      },
      (error) => {
        if (error?.code === 1) {
          dispatch(listEventsRequestAction())
          dispatch(clearEvent())
        }
      },
      {
        enableHighAccuracy: false,
        timeout: 15000,
        maximumAge: 600000
      }
    )
  }, [location, LocationReducer, dispatch])

  return location
}
